export const FRONT = 'front';
export const BACK = 'back';
export const ON = 'on';
export const FACE_KEYS = ['a', 'b', 'c'];
//# sourceMappingURL=constants.js.map